import { Modal } from '@clariness/modal';
import { Store } from 'store';
import * as ReactIntl from 'react-intl';
import { Icon, Text } from '@clariness/clarikit-react';
import { Button } from '@clariness/button';
import { Box } from '@clariness/box';
import { FormattedMessage } from 'react-intl';
import { Flex } from '@clariness/flex';
import { useRedirect } from 'utils/routing';
import { Routing } from 'global/routing';
import { InfoIcon } from '@clariness/clarikit-icons';

type PatientVisit601StatusReminderProps = {
  referralId: string;
};

export const PatientVisit601StatusReminder = ({
  referralId,
}: PatientVisit601StatusReminderProps) => {
  const { closeModal } = Store.useModal();
  const intl = ReactIntl.useIntl();
  const { redirect } = useRedirect();

  const goToUserProfile = () => {
    redirect(Routing.REFERRAL_DETAILS.getPath(referralId));
    closeModal();
  };

  return (
    <Modal
      sx={{
        width: '600px',
      }}
      onClose={closeModal}
    >
      <Modal.Header
        title=""
        sx={{
          height: '74px',
        }}
      >
        <Flex sx={{ alignItems: 'center', gap: 2 }}>
          <Icon source={InfoIcon} size="small" />
          <Text as="span">
            {intl.formatMessage({
              id: 'is.patient_601_visit_status_reminder.title',
              defaultMessage: 'Update needed',
            })}
          </Text>
        </Flex>
      </Modal.Header>
      <Modal.Body>
        <Box
          sx={{
            marginBottom: '46px',
          }}
        >
          <Text as="h2">
            <FormattedMessage
              id="is.patient_601_visit_status_reminder.content_title"
              defaultMessage="601 visit"
            />{' '}
          </Text>
          <br />
          <Text as="p">
            <FormattedMessage
              id="is.patient_601_visit_status_reminder.description"
              defaultMessage="The patient’s clinical study includes a 601 visit. Please go to the patient profile and update the 601 visit status."
            />{' '}
            <br />
          </Text>
        </Box>
      </Modal.Body>
      <Modal.Footer>
        <Flex
          sx={{
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Button variant="secondary" onClick={closeModal}>
            <FormattedMessage
              id="is.update_protocol_modal.cancel_button"
              defaultMessage="Cancel"
            />
          </Button>

          <Button
            sx={{
              marginLeft: '24px',
            }}
            onClick={goToUserProfile}
          >
            <FormattedMessage
              id="is.patient_601_visit_status_reminder.go_to_profile_button"
              defaultMessage="Go to patient profile"
            />
          </Button>
        </Flex>
      </Modal.Footer>
    </Modal>
  );
};
